import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import SimpleInput from 'components/SimpleInput';
import TextArea from 'components/TextArea';
import S from 'modal.scss';
import PhaseType from 'types/phase';
import { getPhaseErrors } from '../../../../../../../reducers';

class Assessment extends Resetter(Validator(React.Component)) {
  state = {
    // it seems like validators from other classes that use 'installerName'
    // in local state are affecting this. giving it some sort of value for now
    installerName: 'N/A',
    auditorName: this.props.auditorName || '',
    overallAssessment: this.props.overallAssessment || '',
    errors: {},
  };

  static VALIDATIONS = {
    installerName: true,
    auditorName: true,
    overallAssessment: true,
  }

  handleSubmit = () => {
    if (!this.validate()) return;
    this.props.updateFormData({
      installerName: this.state.installerName,
      auditorName: this.state.auditorName,
      overallAssessment: this.state.overallAssessment,
      tab: 4,
    });
  }

  handlePrevious = () => this.props.updateFormData({
    installerName: this.state.installerName,
    auditorName: this.state.auditorName,
    overallAssessment: this.state.overallAssessment,
    tab: 2,
  });

  handleAuditorName = e => this.setState({ auditorName: e.target.value });

  handleOverallAssessment = e => this.setState({ overallAssessment: e.target.value });

  render = () => {
    const { auditorName, overallAssessment, errors } = this.state;
    return (<div>
      <h6 className={S.signatureTitle}>Assessment</h6>
      <SimpleInput
        label="Auditor Name*"
        required
        text={auditorName}
        errors={errors.auditorName}
        onChange={this.handleAuditorName}
      />
      <TextArea
        label="Overall Assessment*"
        value={overallAssessment}
        errors={errors.overallAssessment}
        onChange={this.handleOverallAssessment}
        autoFocus
      />
      <Button label="Complete" flat inverse ripple className={S.submit} onClick={this.handleSubmit} />
      <Button label="Previous" flat inverse ripple className={S.submit} onClick={this.handlePrevious} />
    </div>);
  }
}

Assessment.propTypes = {
  phase: PhaseType.isRequired,
  auditorName: PropTypes.string,
  overallAssessment: PropTypes.string,
  errors: PropTypes.shape({
    auditorName: PropTypes.arrayOf(PropTypes.string),
    overallAssessment: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {})(Assessment);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/crewInspection/assessment.jsx